import { render, staticRenderFns } from "./bookingDoneDialog.vue?vue&type=template&id=6851c480&scoped=true&"
import script from "./bookingDoneDialog.vue?vue&type=script&lang=js&"
export * from "./bookingDoneDialog.vue?vue&type=script&lang=js&"
import style0 from "./bookingDoneDialog.vue?vue&type=style&index=0&id=6851c480&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6851c480",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6851c480')) {
      api.createRecord('6851c480', component.options)
    } else {
      api.reload('6851c480', component.options)
    }
    module.hot.accept("./bookingDoneDialog.vue?vue&type=template&id=6851c480&scoped=true&", function () {
      api.rerender('6851c480', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/AirExport/components/routeCentral/bookingDoneDialog.vue"
export default component.exports